import type { Cta } from '@helios/frontend-core';
import { Button, useComponentTracking } from '@helios/frontend-core';
import { PalmettoGoogieBox } from '@palmetto/dsm-components';
import classNames from 'classnames';
import React from 'react';

export interface StatusMessageLayoutProps {
  title: string;
  illustration: React.ReactNode;
  className?: string;
  primaryCTA?: Cta;
  secondaryCTA?: Cta;
  trackingId: string;
}

const StatusMessageLayout: React.FC<StatusMessageLayoutProps> = ({
  title,
  illustration,
  className,
  primaryCTA,
  secondaryCTA,
  trackingId,
}) => {
  useComponentTracking(trackingId);

  return (
    <div className={classNames('flex flex-col items-center max-w-2xl', className)}>
      <p className="heading-300 text-text-primary text-center">{title}</p>
      <PalmettoGoogieBox className="relative w-[274px] my-40">{illustration}</PalmettoGoogieBox>
      <div className="flex flex-col items-center w-full py-8 px-48 gap-6">
        {primaryCTA && <Button {...primaryCTA}>{primaryCTA.label}</Button>}
        {secondaryCTA && <Button {...secondaryCTA}>{secondaryCTA.label}</Button>}
      </div>
    </div>
  );
};

export default StatusMessageLayout;
